import rootActions from "../rootActions";

class allChestActions extends rootActions {
  constructor(params) {
    super(params);
  }
}

export default allChestActions;
